import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { IFinanceiroFaturamento } from "../types/types";

interface Props {
  data?: IFinanceiroFaturamento;
  onClose: () => void;
  title: string;
}

const Info: React.FC<Props> = (props: Props) => {
  const formatCurrency = (value: number | undefined) => {
    if (value === undefined || value === null) return "---";
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full p-4">
        <div className="w-full grid grid-cols-1 gap-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_operacao_patio ?? "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Data do Movimento</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_hora ? formatDateTimeBR(props.data.data_hora) : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Tipo Veículo</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.tipo_veiculo ?? "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Placa</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.placa ?? "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Valor</span>
            <span className="text-sm text-[#666666] font-normal">
              {formatCurrency(props.data?.quantia_paga)}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Transportadora</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.transportadora ?? "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Ativo</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.ativo ? "SIM" : "NÃO"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Usuário</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ?? "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Data de Modificação</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_modificacao ? formatDateTimeBR(props.data.data_modificacao) : "---"}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
